import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { MarkdownRender } from '@gov-nx/component/web';
import { useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useDokumentyReklamaceContextInstance } from '@gov-nx/module/page';
import {
	FormDatePicker,
	FormInput,
	FormTextarea,
	FormWidthElementLayout,
	LayoutGap,
} from '@gov-nx/ui/web';

export interface ComplaintProps {
	code: PageCode;
	formId: string;
}

export const DocumentComplaintView = ({ code, formId }: ComplaintProps) => {
	const { controls, formDefinition, onSubmit } =
		useDokumentyReklamaceContextInstance();
	const isProcessing = controls.processLoading;

	const { t } = useLocale(code);

	return (
		<GovFormWeb
			id={formId}
			formDefinition={formDefinition}
			onSubmit={onSubmit}>
			<LayoutGap gap="xl">
				<MarkdownRender>{t('formular.popis')}</MarkdownRender>
				<FormWidthElementLayout type="l">
					<LayoutGap gap="m">
						<FormInput
							field={{
								name: 'cisloDokladu',
								isDisabled: isProcessing,
								placeholder: t('formular.placeholders.cislo-dokladu'),
								size: 'm',
							}}
							label={{ children: t('formular.pole.cislo-dokladu') }}
						/>
						<FormDatePicker
							field={{
								name: 'platnostDo',
								isDisabled: isProcessing,
								placeholder: t('formular.placeholders.platnost-do'),
							}}
							label={{
								children: t('formular.pole.platnost-do'),
							}}
						/>
						<FormTextarea
							field={{
								name: 'popisReklamace',
								isDisabled: isProcessing,
								placeholder: t('formular.placeholders.popis-reklamace'),
								size: 'm',
								rows: 4,
							}}
							label={{ children: t('formular.pole.popis-reklamace') }}
						/>
					</LayoutGap>
				</FormWidthElementLayout>
			</LayoutGap>
		</GovFormWeb>
	);
};
